import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import { useRegUIClient } from "@foundation/reg-ui-client";
import styles from "./styles.module.css";
import { MAX_TICKERS_PER_WATCHLIST } from "~constants/Portfolio";

const REMAINING_SYMBOL_WARNING_THRESHOLD = 5;

type RemainingSymbolsCountProps = {
  holdingsCount: number;
};

// Only works for words that can be made plural by adding the letter 's', in this case "lot" and "share"
const makePlural = (str: string, count: number) => {
  if (count === 1) {
    return str;
  }

  return `${str}s`;
};

export default function RemainingSymbolsCount(
  props: RemainingSymbolsCountProps
) {
  const { holdingsCount } = props;
  const { session } = useRegUIClient();
  const isSubscriber = Boolean(session?.userInfo?.subscription);
  const maxTickersPerWatchlist = isSubscriber
    ? MAX_TICKERS_PER_WATCHLIST.SUBSCRIBED
    : MAX_TICKERS_PER_WATCHLIST.REGISTERED;

  const remainingSymbolsCount = maxTickersPerWatchlist - holdingsCount;
  const shouldShowWarning =
    remainingSymbolsCount <= REMAINING_SYMBOL_WARNING_THRESHOLD;
  let message;

  if (remainingSymbolsCount > 0) {
    const unit = makePlural("symbol", remainingSymbolsCount);

    message = `You can add ${remainingSymbolsCount} more ${unit} to your watchlist.`;
  } else {
    message = "You've reached your limit of watchlist symbols.";
  }

  return (
    <div
      className={createClasses(
        styles.remainingSymbolsCount,
        shouldShowWarning && styles.warning
      )}
    >
      {message}
      {!isSubscriber && (
        <>
          {" "}
          <a
            className={styles.cta}
            href="https://www.bloomberg.com/subscriptions?in_source=watchlist-subscribe"
          >
            Subscribe to add more symbols and unlock more watchlist features.
          </a>
        </>
      )}
    </div>
  );
}
